export default __webpack_public_path__ + "static/media/resource.1494eb7c.svg";